import React from "react";

import getTooltip from "Utils/getTooltip";

import Icon from "Common/Icon";

export const NETWORK_SIZE_CONSTANTS = {
  4: {
    label: (
      <>
        <span className="sr-only">4 star network size</span>
        <Icon icon="star" flavor="solid" />
        <Icon icon="star" flavor="solid" />
        <Icon icon="star" flavor="solid" />
        <Icon icon="star" flavor="solid" />
      </>
    ),

    tooltip: getTooltip("Network Strength", 4),
  },

  3: {
    label: (
      <>
        <span className="sr-only">3 star network size</span>
        <Icon icon="star" flavor="solid" />
        <Icon icon="star" flavor="solid" />
        <Icon icon="star" flavor="solid" />
        <Icon icon="star" />
      </>
    ),

    tooltip: getTooltip("Network Strength", 3),
  },

  2: {
    label: (
      <>
        <span className="sr-only">2 star network size</span>
        <Icon icon="star" flavor="solid" />
        <Icon icon="star" flavor="solid" />
        <Icon icon="star" />
        <Icon icon="star" />
      </>
    ),

    tooltip: getTooltip("Network Strength", 2),
  },

  1: {
    label: (
      <>
        <span className="sr-only">1 star network size</span>
        <Icon icon="star" flavor="solid" />
        <Icon icon="star" />
        <Icon icon="star" />
        <Icon icon="star" />
      </>
    ),

    tooltip: getTooltip("Network Strength", 1),
  },
};

export const displayDoctorNetworkInfo = (state) => {
  const statesWithDoctorNetworkInfo = ["TX", "CA", "FL", "NY", "VA", "MD", "GA", "NJ", "IL", "AZ"];
  return Boolean(statesWithDoctorNetworkInfo.includes(state));
};
